import React, { useContext } from 'react';

import { PairWalletsContext } from 'context/PairWalletsContext/PairWalletsContext';
import { IDexPair } from 'types/pairs';

interface Props {
  dexPair: IDexPair;
}

const TokenBaseHead: React.FC<Props> = React.memo(({ dexPair }) => {
  const { totalBalances } = useContext(PairWalletsContext);

  return (
    <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column' }}>
      <span>{dexPair.token_base.symbol}</span>
      <span>({totalBalances.base})</span>
    </div>
  );
});

export default TokenBaseHead;
